import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { strings } from "../../resources";
import {
  SignatureFieldContainer,
  DoctorSignatureContainer,
} from "../../../Images/containers";
import { DatePicker } from "../ui";
import { dateEpochToDateTimeString } from "../../../App/helpers/DateTimeFormatConversion";

class FormConsentDermalFillers extends React.Component {
  componentWillMount = () => {
    if (this.props.mode === "create" || this.props.mode === "edit") {
      let todaysDateStr = dateEpochToDateTimeString(new Date(), "-");
      this.props.updateSelectedForm("date_patient_signed", todaysDateStr);
    }
  };

  render = () => {
    const errorFields = this.props.validationErrors.map((error) => {
      return error.field;
    });
    return (
      <div className="createFormContainer">
        <div className="patientFormSectionHeader">
          {strings.form.header.consentDermalFillers}
        </div>
        <div className="personalInformation">
          <Form.Group>
            <Form.Field
              className="textField"
              content={strings.form.consentWording.fillersDescription}
            />
          </Form.Group>
          <Form.Group>
            <Form.Input
              label={strings.form.label.patientPrintName}
              error={errorFields.includes("signed_by_patient")}
              name="signed_by_patient"
              onChange={this.props.handleChange}
              placeholder={strings.form.placeholder.patientPrintName}
              required
              value={this.props.selectedFormData.signed_by_patient || ""}
              width={8}
            />
          </Form.Group>
          <SignatureFieldContainer
            mode={this.props.mode}
            error={errorFields.includes("signature_data_url")}
            headers={this.props.headers}
            readOnly={this.props.mode === "create" ? false : true}
            signatureImagePath={
              this.props.formId ? `signatures/forms/${this.props.formId}` : ""
            }
          />
          <Form.Group>
            <DatePicker
              error={errorFields.includes("date_patient_signed")}
              className="datePatientSigned"
              name="date_patient_signed"
              onChange={this.props.handleDateChange}
              onKeyDown={(e) => this.props.handleDateKeyDown(e)}
              required
              label={strings.form.label.datePatientSigned}
              value={this.props.selectedFormData.date_patient_signed || ""}
            />
          </Form.Group>
          {(this.props.selectedFormData.doctor_signature_path ||
            this.props.mode === "template") && (
            <Form.Group>
              <DoctorSignatureContainer
                containerWidth={240}
                containerHeight={150}
                dateDoctorSigned={this.props.dateDoctorSigned}
                doctorName={this.props.doctorName}
                formId={this.props.formId}
                headers={this.props.headers}
                signaturePathAttachedToForm={
                  this.props.selectedFormData.doctor_signature_path
                }
              />
            </Form.Group>
          )}
        </div>
      </div>
    );
  };
}

FormConsentDermalFillers.propTypes = {
  mode: PropTypes.string.isRequired, //create, view or edit
  selectedFormData: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
};

export default FormConsentDermalFillers;
